<script lang="ts">
    import type RewardsAmountFormatter from "@apps/rewards/lib/RewardsAmountFormatter/RewardsAmountFormatter";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type { TranslationNamespaces } from "@apps/rewards/types";
    import type { GwI18n } from "@modules/i18n/GwI18n/GwI18n";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    import T from "@components/T.svelte";

    import RewardsCurrency from "../RewardsCurrency.svelte";
    import RewardsPoints from "../RewardsPoints.svelte";

    //Props
    export let points: number;
    export let amount: number;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let amountFormatter: RewardsAmountFormatter;
    export let sanitizer: HTMLSanitizerInterface;
    export let i18n: GwI18n;
    export let namespace: TranslationNamespaces;
    export let pointsNamespace: TranslationNamespaces;
</script>

<RewardsPoints
    let:value={{ points, pointsName }}
    {points}
    {amountFormatter}
    {i18n}
    {pointsNamespace}
>
    <RewardsCurrency let:amount {amount} {currencyFormatter} {sanitizer}>
        <T
            {namespace}
            translationKey="points_amount_reward"
            translationOptions={{
                value: points,
                points_name: pointsName,
                amount,
            }}
        />
    </RewardsCurrency>
</RewardsPoints>
